import { useEffect, useMemo, useState } from 'react';

/** Passo do relógio. 60s: os textos que dependem dele têm resolução de minuto. */
const TICK_MS = 60_000;

/**
 * Relógio de parede com passo de 60s, para o "há 7h 36min" não congelar na tela.
 *
 * Existe como hook e não como `Date.now()` no render porque sem re-render o número fica
 * parado — e um plantão fica horas com o dashboard aberto. Cleanup no unmount (regra do
 * `frontend.md`: sem `setInterval` órfão). Compartilhado pelo "Precisa da sua atenção" e
 * pelo sino do header (C-24).
 */
export function useAgora(ativo: boolean): Date {
  const [agora, setAgora] = useState(() => new Date());
  useEffect(() => {
    if (!ativo) return;
    const id = setInterval(() => setAgora(new Date()), TICK_MS);
    return () => clearInterval(id);
  }, [ativo]);
  return agora;
}

/**
 * Relógio que anda com o passo de 60 s E toda vez que um dos `sinais` muda (C-24).
 *
 * O sino passa os dados das queries como sinais: quando chega carga nova, o "agora" é o
 * instante da chegada — o mesmo que o Painel usa (`new Date()` a cada render) — em vez de
 * ficar até 60 s atrasado na borda da carência pós-baixa. Sem sinal novo, devolve o MESMO
 * `Date`, para não remontar a lista a cada render.
 */
export function useAgoraQueAcompanha(sinais: readonly unknown[]): Date {
  const passo = useAgora(true);
  // Dependências dinâmicas de propósito: o relógio é recalculado quando QUALQUER sinal muda.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => new Date(), [passo, ...sinais]);
}
